// import { SectionTitle } from '../common';
import { ScrollSectionTitle } from '@components/scroll-section-title';
import { MediaField } from '../content-media';
import ContactsIcon from '@material-ui/icons/Contacts';
import { scrollToElement, withScrollSpyItem } from '@components/scroll-spy';
import { blue, green, indigo } from '@material-ui/core/colors';
import { Divider, Grid, Typography, Tooltip, IconButton } from '@material-ui/core';
import { useFormContext, useWatch } from 'react-hook-form';
// import { forwardRef, useCallback, useRef } from 'react';
// import { CompanyServiceField } from '../fields';
import { useRecentGetter } from '@lib/common';
import { useSubject } from '@lib/common/hooks/use-subject';
import { useSubscription } from '@lib/common/hooks/use-subscription';
import { useEffect } from 'react';
import { debounceTime, filter, pairwise, map, startWith } from 'rxjs/operators';
// import { useInsightActions } from '../service-insights';
import { CompanyMasters } from '@api/masters';
import { useCompanyFormState } from '../common';
import * as userService from 'services/user';
import { useState } from 'react';
import styled from 'styled-components';
import { VerifiedDetails } from './section-utils';
import LockClosedIcon from '@material-ui/icons/Lock';
import Fab from '@material-ui/core/Fab';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { ExpandLessRounded, ExpandMoreRounded } from '@material-ui/icons';

export const MediaSection = (company_services = null) => {
  const { control } = useFormContext();
  const form = useFormContext();
  const { user } = userService.useUser();
  const { edit, company } = useCompanyFormState();
  const [isLock, setLock] = useState<boolean>(
    (company &&
      company.verified_sections &&
      company.verified_sections.media_section &&
      company.verified_sections.media_section.verified &&
      !edit) ||
      edit,
  );
  const watchOnVerifiedSections = form.watch('verified_sections');
  const verifiedBy =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.media_section &&
    watchOnVerifiedSections.media_section.verified_by;
  const verifiedAt =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.media_section &&
    watchOnVerifiedSections.media_section.verified_at + ' IST';

  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const handleToggleExpand = () => {
    setIsExpanded(prev => !prev);
  };
  return (
    <>
      <Grid
        container
        spacing={2}
        justify="space-between"
        alignItems="center"
        onClick={handleToggleExpand}
        style={{
          cursor: 'pointer',
          userSelect: 'none',
          transition: 'background 0.2s ease',
        }}
        onMouseEnter={e => (e.currentTarget.style.background = '#f5f5f5')}
        onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}>
        <Grid item>
          <ScrollSectionTitle
            id="content-media"
            subTitle="Information about Content Media"
            icon={sectionIcon}>
            Media Details
          </ScrollSectionTitle>
        </Grid>
        <Grid item style={{ paddingBottom: '10px', display: 'flex', alignItems: 'center', gap: 8 }}>
          <Tooltip
            title={
              isLock ? (
                <>
                  {`Verified by ${verifiedBy}`}
                  <br />
                  {`Verified at ${verifiedAt}`}
                </>
              ) : (
                'Click to Lock the Section'
              )
            }>
            {isLock ? (
              <StyledFab
                color="primary"
                aria-label="add"
                style={{ backgroundColor: 'green' }}
                size="small"
                onClick={e => {
                  e.stopPropagation();
                  setLock(false);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    media_section: {
                      verified: false,
                      verified_by: null,
                      verified_at: null,
                      isLockApplied: false,
                    },
                  });
                }}>
                <LockClosedIcon />
              </StyledFab>
            ) : (
              <StyledFab
                color="primary"
                style={{ backgroundColor: 'red' }}
                aria-label="add"
                size="small"
                onClick={e => {
                  e.stopPropagation();
                  setLock(true);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    media_section: {
                      verified: true,
                      verified_by: user.vtr_id,
                      verified_at: new Date().toLocaleString('en-US', { timeZone: 'IST' }),
                      isLockApplied: true,
                    },
                  });
                  // company.verified_sections.attribute_section.verified_by = user.vtr_id;
                  // company.verified_sections.attribute_section.verified = true;
                }}>
                <LockOpenIcon />
              </StyledFab>
            )}
          </Tooltip>

          {isLock && <VerifiedDetails verifiedBy={verifiedBy} verifiedAt={verifiedAt} />}
          <Tooltip title={isExpanded ? 'Collapse section' : 'Expand section'}>
            <IconButton
              size="small"
              onClick={e => {
                e.stopPropagation();
                handleToggleExpand();
              }}>
              {isExpanded ? (
                <ExpandLessRounded color="primary" fontSize="large" />
              ) : (
                <ExpandMoreRounded color="primary" fontSize="large" />
              )}
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>

      <Divider />
      {/* <SectionTitle
              id="company-associated-persons"
              title="Company Associated Person"
              subTitle="Information about Associated Person"
              icon={sectionIcon}
            />
            <Divider /> */}
      <br />
      <Grid container spacing={1} style={{ display: isExpanded ? 'flex' : 'none' }}>
        <Grid item xs={12}>
          <MediaField
            company_vtr_id={company.vtr_id}
            control={control}
            company_services={company_services}
            isLock={isLock}
            name="media_and_services"
          />
        </Grid>
      </Grid>
    </>
  );
};
const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;

const sectionIcon = <ContactsIcon fontSize="large" style={{ color: blue[600] }} />;

interface TitleProps {
  title: React.ReactNode;
  subTitle: React.ReactNode;
  icon: React.ReactNode;
}

const SectionTitle = withScrollSpyItem(
  ({ title, icon, subTitle, id }: TitleProps & { id: string }, ref: any) => (
    <Grid container ref={ref} id={id} spacing={2} alignItems="center">
      <Grid item>{icon}</Grid>
      <Grid item>
        <Typography variant="h5">{title}</Typography>
        <Typography color="textSecondary" variant="body2">
          {subTitle}
        </Typography>
      </Grid>
    </Grid>
  ),
);
